import { createSlice } from '@reduxjs/toolkit'

/*
    Multiple components need the state of the side nav being expanded or not to do css calculations.
 */
export const sideNavSlice = createSlice({
    name: 'sidenav',
    initialState: {
        expanded: true,
    },
    reducers: {
        setExpanded: (state, action) => {
            return {
                ...state,
                expanded: action.payload,
            }
        },
    },
})

export const { setExpanded } = sideNavSlice.actions;

export default sideNavSlice.reducer;